export enum GroupDivision {
    NotRegistered = 0,
    NacaoDigital = 1
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/GroupDivision.ts